import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import * as utils from '../../shared/utils';
import { deepPurple } from '@material-ui/core/colors';
import Title, { flushTitle } from 'reactjs-title'

export default function HeaderJobseeker(props) {
  const { profile } = props;
  return (
    <Paper square={true} elevation={4}>
    <Title render={`Chat with ${profile.name}`}/>
    <Grid container direction="row" justify="space-between" alignItems="center" >
      <Grid item>
        <ListItem key={profile.uuid}>
          <ListItemAvatar>
            <Avatar style={{ backgroundColor: deepPurple[500] }}>
              { utils.nameToInitials(profile.name) }
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={profile.name} secondary={profile.email} />
        </ListItem>
      </Grid>
      <Grid item>
        {props.actions}
      </Grid>
    </Grid>
  </Paper>
  );
}
